import React from 'react';
import { BoltIcon, BellIcon, ShieldCheckIcon, WrenchIcon, ThermometerIcon } from 'lucide-react';

const SpecsTable = () => {
    const specs = [
        {
            category: "Elektriksel Özellikler",
            icon: <BoltIcon className="w-5 h-5" />,
            items: [
                { name: "Güç", value: ["7.4 kW (Ayarlanabilir)", "22 kW (Ayarlanabilir)"] },
                { name: "Faz", value: ["1 Faz", "3 Faz"] },
                { name: "Akım", value: ["32A (Max)", "32A (Max)"] },
                { name: "Konnektör Tipi", value: ["Type2 (Soket veya Kablo)"] },
                { name: "Çıkış Sayısı", value: ["1"] },
            ]
        },
        {
            category: "Fonksiyonel Özellikler",
            icon: <WrenchIcon className="w-5 h-5" />,
            items: [
                { name: "Kontrol Tipi", value: ["RFID Kart Okuyucu"] },
                { name: "Dil Desteği", value: ["Türkçe"] },
                { name: "Durum Göstergesi", value: ["LED"] },
            ]
        },
        {
            category: "Koruma",
            icon: <ShieldCheckIcon className="w-5 h-5" />,
            items: [
                {
                    name: "Koruma Özellikleri",
                    value: ["Yıldırım, Yüksek Gerilim, Düşük Gerilim, Kaçak Akım, Aşırı Akım, Sıcaklık Koruma, Acil Stop"]
                },
                { name: "Koruma Sınıfı", value: ["IK10", "IP54"] },
            ]
        },
        {
            category: "Fiziksel Özellikler",
            icon: <BellIcon className="w-5 h-5" />,
            items: [
                { name: "Ölçüler", value: ["440x300x158 mm"] },
                { name: "Ağırlık", value: ["7.5 kg"] },
                { name: "Montaj", value: ["Duvar, Ayaklı Stand"] },
            ]
        },
        {
            category: "Ortam Koşulları",
            icon: <ThermometerIcon className="w-5 h-5" />,
            items: [
                { name: "Sıcaklık", value: ["Çalışma: -20°C ~ +55°C, Depolama: -30°C ~ +80°C"] },
                { name: "Nem", value: ["%95'e kadar (Yoğuşmasız)"] },
            ]
        },
    ];

    return (
        <div className="specs-table">
            {specs.map((category, idx) => (
                <div key={idx} className={`category-section ${idx % 2 === 0 ? 'even' : ''}`}>
                    <div className="category-header">
                        {React.cloneElement(category.icon, { className: 'category-icon' })}
                        <h3>{category.category}</h3>
                    </div>
                    <div className="category-items">
                        {category.items.map((item, itemIdx) => (
                            <div key={itemIdx} className="spec-item">
                                <div className="spec-name">{item.name}</div>
                                <div className="spec-value">
                                    {item.value.map((val, valIdx) => (
                                        <span key={valIdx}>{val}</span>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export const BasicStation = () => {
    return <SpecsTable />;
};

export const PremiumStation = () => {
    return <SpecsTable />;
};

export const SmartStation = () => {
    return <SpecsTable />;
};

export const DualStation = () => {
    return <SpecsTable />;
};

export default SpecsTable;